// navLinks.js
export const navLinks = [
  // Home
  {
    key: "home",
    title: "Home",
    to: "/",
  },
  // about us
  {
    key: "aboutus",
    title: "About Us ▾",
    leftImage: "/assets/images/about/manet_building.webp",
    columns: [
      [
        { name: "About MANET", to: "/aboutus/about-manet" },
        { name: "Vision & Mission", to: "/aboutus/vision-mission" },
        { name: "About MIT Group of Institutions", to: "/aboutus/mit-group" },
        { name: "Board of Bodies", to: "/aboutus/board-bodies" },
      ],
      [
        { name: "From the Principal’s Desk", to: "/aboutus/principals-desk" },
        { name: "Awards & Recognition", to: "/aboutus/awards" },
        { name: "Accreditations & Approvals", to: "/aboutus/accreditations" },
      ],
    ],
  },

  //   academics
  {
    key: "academics",
    title: "Academics ▾",
    leftImage: "/assets/images/about/manet_building.webp",
    columns: [
      [
        { name: "Programs Offered", to: "/academics/programs-offered" },
        { name: "Ship in Campus & Labs", to: "/academics/ship-in-campus" },
        { name: "Syllabus", to: "/academics/syllabus" },
        { name: "Academic Calendar", to: "/academics/academic-calendar" },
      ],
      [
        {
          name: "Officer-Like Qualities (OLQ)",
          to: "/academics/officer-qualities",
        },
        { name: "Faculty Information", to: "/academics/faculty-info" },
        { name: "Faculty Research", to: "/academics/faculty-research" },
        { name: "Achievements", to: "/academics/achievements" },
        { name: "Feedback Report", to: "/academics/feedback-report" },
      ],
    ],
  },

  // admission
  {
    key: "admissions",
    title: "Admissions ▾",
    leftImage: "/assets/images/about/manet_building.webp",
    columns: [
      [
        { name: "Admission 2026", to: "/admissions/admission-2026" },
        { name: "Schedule Guideline", to: "/admissions/schedule-guidline" },
        { name: "Admission Procedure", to: "/admissions/admission-procedure" },
        {
          name: "Course Wise Eligibility",
          to: "/admissions/course-eligibilty",
        },
        // {
        //   name: "DNS- Female Sponsorship",
        //   to: "/admissions/DNS",
        // },
      ],
      [
        { name: "Fee structure", to: "/admissions/fee-structure" },
        { name: "Scholarship Policy", to: "/admissions/scholarships" },
        { name: "Brochure", to: "/admissions/brochure" },
        { name: "FAQ", to: "/admissions/admission-faq" },
      ],
    ],
  },
  // placement
  {
    key: "placements",
    title: "Placements ▾",
    leftImage: "/assets/images/about/manet_building.webp",
    columns: [
      [
        { name: "Placement Cell", to: "/placement/placement-cell" },
        { name: "Placement Teams", to: "/placement/placement-team" },
        { name: "Placement Training", to: "/placement/placement-training" },
        { name: "MOU", to: "/placement/mou" },
      ],
      [
        { name: "Top Recruiters", to: "/placement/top-recruiters" },
        { name: "Placement Statistics", to: "/placement/placement-statistics" },
        { name: "Sample CV", to: "/placement/sample-cv" },
      ],
    ],
  },
  // life at manet
  {
    key: "lifeatcampus",
    title: "Life@ Campus ▾",
    //  leftImage: "/assets/images/about/manet_building.webp",
    columns: [
      [
        { name: "Life @ MANET", to: "/lifeatcampus/campus-life" },
        { name: "Conduct at campus", to: "/lifeatcampus/conduct-at-campus" },
        { name: "Accommodation", to: "/lifeatcampus/accommodation" },
        {
          name: "National Maritime Day",
          to: "/lifeatcampus/national-maritime-day",
        },
        {
          name: "Vishwanath Sport Campus",
          to: "/lifeatcampus/vishwanath-sport",
        },
        { name: "MANET Blogs", to: "/lifeatcampus/manet-blogs" },
      ],
      [
        { name: "MIT - Persona Fest", to: "/lifeatcampus/mit-persona-fest" },
        { name: "Library", to: "/lifeatcampus/library" },
        { name: "Sports", to: "/lifeatcampus/sports" },
        { name: "Student Grievance", to: "/lifeatcampus/student-grievance" },
        { name: "Happenings", to: "/lifeatcampus/happenings" },
        { name: "Gallery", to: "/lifeatcampus/gallery" },
      ],
    ],
  },
  // examinations
  {
    key: "examinations",
    title: "Examinations ▾",
    columns: [
      [
        { name: "Notices & Circulars", to: "/examinations/notices" },
        { name: "Exam Timetable", to: "/examinations/exam-timetable" },
      ],
    ],
  },

  // Alumni
  {
    key: "alumni",
    title: "Alumni ▾",
    columns: [
      [
        { name: "Proud Alumni", to: "/alumni/proud-alumni" },
        { name: "Alumni Registration Form", to: "https://docs.google.com/forms/d/e/1FAIpQLSeMFd7XDa2g0p6LV1eTqPFffoC2Xhsb-ucLID4RRpZbM7eFvQ/viewform?pli=1" },
      ],
    ],
  },

  // contact
  {
    key: "contact",
    title: "Contact Us",
    to: "/contact",
  },


];
